import { MapGroup, useGetSessionContextQuery } from '@common/services/session';
import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export const RequireOFARole = () => {
  const navigate = useNavigate();

  const { data: context, isLoading: isSessionLoading } = useGetSessionContextQuery();

  useEffect(() => {
    if (!isSessionLoading && (!context?.groups?.includes(MapGroup.MAP_OFA) || !context?.organismeId)) {
      // on redirige vers la page refuse si pas acces a OFA
      navigate('/acces-refuse');
    }
  }, [isSessionLoading, context]);

  // si le context est déja mis en cache
  if (!context?.groups?.includes(MapGroup.MAP_OFA) || !context?.organismeId) {
    // on redirige vers la page refuse si pas acces a OFA
    navigate('/acces-refuse');
    return <></>;
  }
  return (context) ? <Outlet /> : <></>;
};
